module.exports = __webpack_public_path__ + "img/default-avatar-profile.0fccfed3.jpeg";